"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO8601ToUTCms = void 0;
const MILLISECONDS_LENGTH = 3;
const ISO_8601_DATETIME_REGEX = /^(\d{4})-([01]\d)-([0-3]\d)([T ]([0-2]\d):([0-5]\d)(?::([0-5]\d)(?:\.(\d{3,6}))?)?(Z|([+-\u2212])(\d\d)(?::?(\d\d))?)?)?$/;
const ISO8601ToUTCms = (str) => {
    const match = str.match(ISO_8601_DATETIME_REGEX);
    if (!match) {
        return NaN;
    }
    const [, yearStr, monthStr, dayStr, timeIndicator, hoursStr, minutesStr, secondsStr = '0', msStr = '0', zuluTimeIndicator, offset, hourUTCStr = '0', minutesUTCStr = '0',] = match;
    const year = Number.parseInt(yearStr, 10);
    const month = Number.parseInt(monthStr, 10) - 1;
    const day = Number.parseInt(dayStr, 10);
    if (!timeIndicator) {
        return Date.UTC(year, month, day);
    }
    const hour = Number.parseInt(hoursStr, 10);
    const minutes = Number.parseInt(minutesStr, 10);
    const seconds = Number.parseInt(secondsStr, 10);
    const milliseconds = Number.parseInt(msStr.slice(0, MILLISECONDS_LENGTH), 10);
    if (!zuluTimeIndicator || zuluTimeIndicator === 'Z') {
        return Date.UTC(year, month, day, hour, minutes, seconds, milliseconds);
    }
    const sign = offset === '+' ? 1 : -1;
    const hourUTC = Number.parseInt(hourUTCStr, 10) * sign;
    const minutesUTC = Number.parseInt(minutesUTCStr, 10) * sign;
    return Date.UTC(year, month, day, hour - hourUTC, minutes - minutesUTC, seconds, milliseconds);
};
exports.ISO8601ToUTCms = ISO8601ToUTCms;
//# sourceMappingURL=ISO8601ToUTCms.js.map